import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { PrivacyTeamRecord } from '../../Common/ConsumerModels/SubscriberRecord';

export function useGetAllPrivacyTeams(shouldReload: boolean) {
  const [privacyTeamList, setPrivacyTeamList] = useState<PrivacyTeamRecord[]>([]);
  const [privacyTeamListLoading, setPrivacyTeamListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);
  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */
    if (!shouldReload) {
      setPrivacyTeamListLoading(true);
      httpClient
        .get<PrivacyTeamRecord[]>(`${__API_BASE_URL__}/subscriber/getAllPrivacyTeams`, {
          resource: __CLIENT_ID__,
          headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
          },
        })
        .then(({ data }) => {
          setPrivacyTeamList(data);
          setPrivacyTeamListLoading(false);
        });
    }
  }, [shouldReload]);
  return [privacyTeamList, privacyTeamListLoading] as const;
}
